/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from 'react';
import Button from '../../../Button';
import { viewLoading } from '../../../../utils/loading';
import { putTaxSingoTaxPayerSingo } from '../../../../apis/tax-portal/tax-singo/tax-singo';
import { classnames } from '../../../../utils/text';


/**
 * 메모는 scheduled 의 메모 
 * scheduled.data 의 메모는 text 사용
 */

const TaxSingoItemMemo = (props) => {

  const { taxpayerSingo, reSubmit } = props

  const [isMemoMode, setIsMemoMode] = useState(false)

  const [dataMemo, setDataMemo] = useState("");

  const handleOnTextAreaChange = (e) => {
    setDataMemo(e.target.value);
  };

  const openDataMemo = (isOpen) => {
    if (isOpen) {
      setDataMemo(taxpayerSingo?.memo || '')
    }
    setIsMemoMode(isOpen)
  }

  const onChange = useCallback((updatedData) => {
    const updatedTaxpayerSingo = {
      ...taxpayerSingo,
      ...updatedData,
    }
    viewLoading(true);

    putTaxSingoTaxPayerSingo(
      taxpayerSingo.idx,
      updatedTaxpayerSingo
    )
      .then((res) => {
        console.log(res);
        reSubmit();
      })
      .finally(() => {
        viewLoading(false);
      });
  }, [reSubmit, taxpayerSingo])

  const saveMemo = useCallback(() => {
    const updatedData = {
      ...taxpayerSingo,
      memo: dataMemo
    }
    onChange(updatedData)
    openDataMemo(false)
  }, [dataMemo, onChange, taxpayerSingo])

  return <div className={classnames("tax-singo-item-wrap", {
    "tax-singo-item-memo-open": isMemoMode
  })}>
    <i
      className='bx bx-notepad'
      onClick={openDataMemo}
      style={{
        cursor: 'pointer',
        fontSize: '20px',
        opacity: taxpayerSingo.memo ? 1 : 0.5
      }}
    />
    <div className='tax-singo-item-drop-box'>
      <div className='tax-sing-item-drop-box-header'>
        {taxpayerSingo?.memo || ''}
      </div>
      <div className="tax-singo-item-bottom">
        <Button
          label={'메모수정'}
          size="tiny"
          color="info"
          onClick={() => openDataMemo(true)}
        />
      </div>
    </div>
    {
      isMemoMode &&
      <div className='tax-singo-item-drop-box tax-singo-item-memo-box'>
        <div className='tax-sing-item-drop-box-header'>
          메모
        </div>
        <div className='tax-sing-item-drop-box-contents'>
          <textarea
            name="tax-singo-item-memo"
            className="tax-singo-item-memo"
            placeholder="메모 입력"
            value={dataMemo}
            onChange={handleOnTextAreaChange}
          />
        </div>
        <div className='tax-singo-item-bottom'>
          <Button
            label={'취소'}
            size="tiny"
            color="danger"
            onClick={() => openDataMemo(false)}
          />

          <Button
            label={'저장'}
            size="tiny"
            onClick={() => saveMemo()}
          />
        </div>
      </div>
    }
  </div>
}

export default TaxSingoItemMemo